import { memo, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { TRANSLATION_KEYS } from 'partner360/features/contacts/model/constants'
import { IContactSearchItem } from 'partner360/features/contacts/model/types'

import styles from './ContactSearchItem.module.scss'

interface IContactSearchItemProps {
  item: IContactSearchItem
  onSelect: (item: IContactSearchItem) => void
  onAddToContacts: (item: IContactSearchItem) => void
}

export const ContactSearchItem = memo(
  ({ item, onSelect, onAddToContacts }: IContactSearchItemProps) => {
    const handleAddToContacts = useCallback(
      (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        e.stopPropagation()
        onAddToContacts(item)
      },
      [onAddToContacts, item]
    )

    const handleSelect = useCallback(() => {
      onSelect(item)
    }, [onSelect, item])

    return (
      <div className={styles.option} onClick={handleSelect}>
        <div className={styles.optionContent}>
          <div className={styles.name}>{item.fullName}</div>
          <div className={styles.info}>{item.email}</div>
        </div>
        {!item.isInContacts && (
          <Button variant="text" onClick={handleAddToContacts}>
            <i className="kbase kbase-add" />{' '}
            <Translation text={TRANSLATION_KEYS.addToTheList} span />
          </Button>
        )}
      </div>
    )
  }
)
